<template>
	<div class="item-container">
		<div class="d-flex bg-white item slim" :class="{right: type === 'flexible'}">
			<div class="d-flex fixed icon">
				<I :name="icon" />
			</div>
			<div class="d-flex align-items-center flex-fill">
				<div class="flex-fill">
					<div class="value w-bold">{{ title }}</div>
					<div class="">{{ description }}</div>
					<div class="mt-2">
						<span v-if="asService" class="tag" :class="{'tag-service': asService}">Paketerad tjänst</span>
						<span class="tag nobreak" :class="{'tag-input': inCs}">Officiellt bokslut</span>
						<span class="tag nobreak" :class="{'tag-input': inSie}">SIE-import</span>
<!--            <div v-if="type === 'flexible'" style="margin-bottom: 0.5rem;"></div>-->
						<span class="tag" :class="{'tag-output': outPresentation}">Presentation</span>
						<span class="tag" :class="{'tag-output': outReport}">Rapport</span>
						<span v-if="outWebreport" class="tag" :class="{'tag-output': outWebreport}">Webbrapport</span>
						<span class="tag" :class="{'tag-output': outCheatSheet}">Lathund</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* tslint:disable */

export default {
	name: "TemplateSelection",
	props: ["type", "title", "description", "icon"],
  computed: {
	  // ['company', 'competitors', 'valuation', 'closingmeeting', 'preClosingMeeting', 'futuremeeting', 'yearendmeeting', 'yearreview', 'cashflow', 'flexible']
    inCs() {
      return ['company', 'competitors', 'valuation', 'futuremeeting', 'cashflow', 'flexible', 'industryAnalysis', 'competitorAnalysis', 'webreport_cashflow'].indexOf(this.type) >= 0;
    },
    inSie() {
      return ['company', 'competitors', 'valuation', 'closingmeeting', 'preClosingMeeting', 'futuremeeting', 'yearendmeeting', 'yearreview', 'cashflow', 'flexible', 'industryAnalysis', 'competitorAnalysis', 'webreport_cashflow'].indexOf(this.type) >= 0;
    },
    outPresentation() {
      return ['company', 'competitors', 'valuation', 'closingmeeting', 'preClosingMeeting', 'futuremeeting', 'yearendmeeting', 'yearreview', 'cashflow', 'flexible', 'industryAnalysis', 'competitorAnalysis'].indexOf(this.type) >= 0;
    },
    outReport() {
      return ['company', 'valuation', 'cashflow'].indexOf(this.type) >= 0;
    },
    outCheatSheet() {
      return ['closingmeeting', 'preClosingMeeting', 'futuremeeting', 'yearendmeeting'].indexOf(this.type) >= 0;
    },
    outWebreport() {
      return ['webreport_cashflow'].indexOf(this.type) >= 0;
    },
    asService() {
      return ['industryAnalysis', 'competitorAnalysis'].indexOf(this.type) >= 0;
    },
  }
};
</script>

<style scoped lang="scss">
.tag {
	font-size: 0.875rem;
	color: col("colors.LightGrey");
	background-color: col("colors.Light");
	border: 1px solid col("colors.LightGrey");
	border-radius: 1rem;
	padding: 0.1rem 0.5rem;
	margin-right: 0.5rem;
}

.tag-input {
	color: darken(col("colors.Primary"), 20%);
	font-weight: 600;
	background-color: rgba(col("colors.Primary"), 0.2);
	border-color: col("colors.Primary");
}
.tag-output {
	color: darken(col("colors.Secondary"), 20%);
	font-weight: 600;
	background-color: rgba(col("colors.Secondary"), 0.2);
	border-color: col("colors.Secondary");
}
.tag-service {
	color: darken(col("colors.Tertiary"), 20%);
	font-weight: 600;
	background-color: rgba(col("colors.Tertiary"), 0.2);
	border-color: col("colors.Tertiary");
}

</style>
